module.exports = __webpack_public_path__ + "img/Millionaire-5.d22b6116.gif";